<template>
  <el-container class="layout-container">
    <el-aside :width="sidebar.opened ? '220px' : '64px'" class="sidebar-container">
      <div class="logo">
        <div class="logo-icon">YM</div>
        <span v-show="sidebar.opened" class="logo-text">管理后台</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        :collapse="!sidebar.opened"
        background-color="#FFFFFF"
        text-color="#606266"
        active-text-color="#2979ff"
        :unique-opened="true"
        router
      >
        <template v-for="route in menuRoutes">
          <el-menu-item
            v-if="route.children && route.children.length === 1 && !route.children[0].children"
            :key="resolvePath(route.path, route.children[0].path)"
            :index="resolvePath(route.path, route.children[0].path)"
          >
            <i :class="route.children[0].meta.icon"></i>
            <span slot="title">{{ route.children[0].meta.title }}</span>
          </el-menu-item>
          <el-submenu
            v-else-if="route.children && route.children.length > 1"
            :key="route.path"
            :index="route.path"
          >
            <template slot="title">
              <i :class="route.meta && route.meta.icon"></i>
              <span>{{ route.meta && route.meta.title }}</span>
            </template>
            <el-menu-item
              v-for="child in route.children"
              :key="resolvePath(route.path, child.path)"
              :index="resolvePath(route.path, child.path)"
            >
              <i :class="child.meta && child.meta.icon"></i>
              <span slot="title">{{ child.meta && child.meta.title }}</span>
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="header-container">
        <div class="header-left">
          <i
            :class="sidebar.opened ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
            class="toggle-btn"
            @click="toggleSidebar"
          ></i>
          <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="$route.meta.title">{{ $route.meta.title }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-dropdown @command="handleCommand">
          <span class="user-dropdown">
            <div class="avatar-mini">{{ (userInfo.nickname || '管')[0] }}</div>
            {{ userInfo.nickname || '管理员' }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>

      <el-main class="main-container">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  computed: {
    ...mapGetters(['sidebar', 'userInfo', 'permissionRoutes']),
    activeMenu() {
      return this.$route.path
    },
    menuRoutes() {
      return this.permissionRoutes.filter(r => !r.hidden && r.children && r.children.length > 0)
    }
  },
  methods: {
    resolvePath(parent, child) {
      if (parent.endsWith('/')) return parent + child
      return parent + '/' + child
    },
    toggleSidebar() {
      this.$store.dispatch('user/toggleSidebar')
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.$store.dispatch('user/logout')
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style lang="scss">
.layout-container {
  height: 100vh;
}

.sidebar-container {
  background: #FFFFFF;
  border-right: 1px solid var(--border-default);
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.03);
  transition: width 0.3s;
  overflow: hidden;

  .logo {
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid var(--border-light);
    overflow: hidden;
    white-space: nowrap;
  }

  .logo-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: var(--gradient-primary);
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    font-style: italic;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .logo-text {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    margin-left: 10px;
  }

  // 菜单项样式覆盖
  .el-menu-item {
    height: 48px;
    line-height: 48px;
    margin: 2px 8px;
    border-radius: 6px;
    font-size: 14px;

    &.is-active {
      background: #EBF3FF !important;
      color: #2979ff !important;
      font-weight: 500;
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 20px;
        background: #2979ff;
        border-radius: 2px;
      }
    }

    &:hover {
      background: #F5F7FA !important;
    }

    i {
      font-size: 17px;
      margin-right: 8px;
    }
  }

  .el-submenu__title {
    height: 48px;
    line-height: 48px;
    margin: 2px 8px;
    border-radius: 6px;

    &:hover {
      background: #F5F7FA !important;
    }

    i {
      font-size: 17px;
      margin-right: 8px;
    }
  }

  .el-submenu .el-menu-item {
    height: 44px;
    line-height: 44px;
    padding-left: 52px !important;
    min-width: auto;
  }
}

.header-container {
  background: #FFFFFF;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  height: 56px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  z-index: 10;

  .header-left {
    display: flex;
    align-items: center;
  }

  .toggle-btn {
    font-size: 20px;
    cursor: pointer;
    color: var(--text-secondary);
    transition: color 0.2s;
    &:hover {
      color: var(--color-primary);
    }
  }

  .breadcrumb {
    margin-left: 20px;
  }

  .user-dropdown {
    cursor: pointer;
    color: var(--text-secondary);
    display: flex;
    align-items: center;
    font-size: 14px;
    &:hover {
      color: var(--color-primary);
    }
  }

  .avatar-mini {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--gradient-primary);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
  }
}

.main-container {
  background: var(--bg-page);
  overflow-y: auto;
}
</style>
